import { render, staticRenderFns } from "./ListCurrent.vue?vue&type=template&id=1f6ed338"
import script from "@/views/modules/FormatSettings/js/ListCurrent.js?vue&type=script&lang=js&external"
export * from "@/views/modules/FormatSettings/js/ListCurrent.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports